const AWAITING = 'awaiting'
const TO_TO = 'to_do'
const DOING = 'doing'
const DONE = 'done'
const AVAILABLE_STATUS_TYPES = [AWAITING, TO_TO, DOING, DONE]
const VISIBLE_STATUS_TYPES = [TO_TO, DOING, DONE]
const SELECTABLE_STATUS_TYPES = [DOING, DONE]

module.exports = {
  AWAITING,
  TO_TO,
  DOING,
  DONE,
  AVAILABLE_STATUS_TYPES,
  VISIBLE_STATUS_TYPES,
  SELECTABLE_STATUS_TYPES
}
